var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vf-ta",class:[
    {'vf-ta-disabled': _vm.disabled},
    {'vf-ta-dotted': _vm.dotted},
    {'vf-ta-designer': _vm.designer},
    {'vf-ta-invalid': _vm.validation.done && !_vm.validation.valid } ],on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave,"mouseup":function($event){return _vm.handleOptionMouseUp($event)}}},[_c('textarea',{style:('height: ' + _vm.getHeight() + 'px;'),attrs:{"lines":_vm.lines,"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }